export const useCanEdit = (
    isChartViewedOnDashboard: boolean,
    canUserEditDashboard: boolean,
): boolean => {
    // We want to insure that the user cannot edit only if:
    // - the chart is viewed on a dashboard and he has edit rights on the dashboard
    // - the chart is not viewed on a dashboard
    const canEdit =
        (isChartViewedOnDashboard && canUserEditDashboard) ||
        !isChartViewedOnDashboard;
    return canEdit;
};
